import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { clearEndpoints, getEndpoints } from '../../../../actions/security/Endpoint';

export const EndpointSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearEndpoints,
  dispatchGetEndpoints,
  ...rest
}) => {
  
  useLayoutEffect(() => () => dispatchGetEndpoints(), []); 
  const handleInputChange = (inputValue) => {
    if (inputValue.trim().length && inputValue.trim().length >= 3) {
      dispatchGetEndpoints({ query:  [`name:${inputValue}`] });
    }
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={handleInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

EndpointSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetEndpoints: PropTypes.func.isRequired,
  dispatchClearEndpoints: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

EndpointSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Buscar puntos de acceso',
};

const mapStateToProps = ({ SecurityUnit }) => ({
  options: SecurityUnit.Endpoint.getIn(['all', 'content', 'content']).map((endpoint) => ({
    value: endpoint.id,
    label: `${endpoint.name} (${endpoint.route})`,
  })),
  loading: SecurityUnit.Endpoint.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetEndpoints: getEndpoints,
  dispatchClearEndpoints: clearEndpoints,
};

export default connect(mapStateToProps, mapDispatchToProps)(EndpointSelect);
